module.exports = __webpack_public_path__ + "static/img/444.719b0bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/444.png
// module id = xgug
// module chunks = 0